<template>
	<div class="quicklink">
		<div class="icon">
			<img
				v-if="quicklink.icon"
				:src="quicklink.icon.url"
			/>
		</div>
		<div class="quicklink__list">
			<h5
				v-if="quicklink.title"
				v-html="quicklink.title"
			></h5>
			<transition name="accordion">
				<ul>
					<menu-item
						v-for="(link, index) in quicklink.links"
						:key="index"
						:menu_item="link.link"
					></menu-item>
				</ul>
			</transition>
		</div>
	</div>
</template>

<script>
import MenuItem from './MenuItem.vue';

export default {
	data() {
		return {
			window: {
				width: 0,
				height: 0,
			},
			isAccordionOpen: false,
		};
	},
	props: {
		quicklink: {
			type: Object,
			required: true,
		},
	},
	methods: {
		handleResize() {
			this.window.width = window.innerWidth;
			this.window.height = window.innerHeight;
		},
		toggleAccordion() {
			this.isAccordionOpen = !this.isAccordionOpen;
			this.$emit('accordionToggled', this.isAccordionOpen); // Emit event with the current state of the accordion
		},
	},
	created() {
		window.addEventListener('resize', this.handleResize);
		window.addEventListener('load', this.handleResize);
		this.handleResize();
	},
	destroyed() {
		window.removeEventListener('resize', this.handleResize);
	},
	components: {
		MenuItem,
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.quicklink {
	display: grid;
	grid-template-columns: 40px auto;
	column-gap: 20px;

	&.acc {
		grid-template-columns: 40px auto 40px;
	}

	.icon img {
		max-width: 100%;
		height: 48px;
	}

	&__list {
		h5 {
			margin: 0;
			font: normal normal normal 14px/20px var(--primary-font-family);
			text-transform: uppercase;
			color: var(--cobalt);

			.standard_header & {
				color: var(--midnight);
			}
		}

		ul {
			list-style: none;
			padding: 0;
			margin-top: 16px;
			display: flex;
			flex-direction: column;
			gap: 16px;

			li {
				&::v-deep {
					.parent_container {
						padding: 0;

						.menu_item__parent__primary_link {
							color: var(--white);

							@media (max-width: $mobile-xl) {
								text-decoration: underline;
							}

							.standard_header & {
								color: var(--midnight);
							}
						}
					}
				}
			}
		}

		@media (max-width: $mobile-xl) {
			padding-top: 0;
		}
	}

	.toggle {
		cursor: pointer;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;

		.icon-wrapper {
			height: 25px;
			display: flex;
			justify-content: center;
			align-items: center;

			@media (max-width: $mobile-xl) {
				padding-top: 16px;
			}

			.standard_header & {
				svg {
					path {
						fill: var(--midnight);
					}
				}
			}
		}
	}

	.accordion-enter-active,
	.accordion-leave-active {
		transition: height 0.3s ease, opacity 0.3s ease;
		overflow: hidden;
	}

	.accordion-enter,
	.accordion-leave-to {
		height: 0;
		opacity: 0;
	}
}
</style>
